import SnareDrumIcon from "@/assets/images/icons/instrument-snare-drum.svg";
import VibraphoneIcon from "@/assets/images/icons/instrument-vibraphone.svg";
import type { HomeSurveyInstrumentId } from "@/lib/homeSurveyOptions";
import { BRAND_COLORS } from "@/lib/brandColors";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import React from "react";

type IconName = React.ComponentProps<typeof MaterialCommunityIcons>["name"];

/** Verified against MaterialCommunityIcons glyphmap — invalid names render as ? on native. */
const INSTRUMENT_ICON: Record<Exclude<HomeSurveyInstrumentId, "drums" | "vibraphone">, IconName> = {
  piano: "piano",
  guitar: "guitar-acoustic",
  bass: "music-clef-bass",
  vocals: "microphone",
  saxophone: "saxophone",
  trumpet: "trumpet",
};

const CUSTOM_INSTRUMENT_ICON: Partial<
  Record<
    HomeSurveyInstrumentId,
    React.FC<{
      width: number;
      height: number;
      color: string;
      accessibilityElementsHidden?: boolean;
    }>
  >
> = {
  drums: SnareDrumIcon,
  vibraphone: VibraphoneIcon,
};

type Props = {
  id: HomeSurveyInstrumentId;
  size?: number;
  color?: string;
};

export function HomeSurveyInstrumentIcon({
  id,
  size = 22,
  color = BRAND_COLORS.text,
}: Props) {
  const CustomIcon = CUSTOM_INSTRUMENT_ICON[id];
  if (CustomIcon) {
    return (
      <CustomIcon
        width={size}
        height={size}
        color={color}
        accessibilityElementsHidden
      />
    );
  }

  return (
    <MaterialCommunityIcons
      name={INSTRUMENT_ICON[id as Exclude<HomeSurveyInstrumentId, "drums" | "vibraphone">]}
      size={size}
      color={color}
      accessibilityElementsHidden
    />
  );
}
